
import actions from './actions';

export default {
  actions: actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/global/index.js